import React from 'react';

import { globalAdminsRoute } from '@lumapps/customer/routes';
import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiAccountPlus } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

import { CUSTOMER_BACK_OFFICE } from '../../keys';

export interface GlobalAdministratorsSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

export const GlobalAdministratorsSideNavigation = (props: Partial<GlobalAdministratorsSideNavigationProps>) => {
    const { isAllowed, ...restOfProps } = props;

    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            route={globalAdminsRoute}
            label={translateKey(CUSTOMER_BACK_OFFICE.GLOBAL_ADMINS)}
            icon={mdiAccountPlus}
        />
    );
};

GlobalAdministratorsSideNavigation.displayName = 'SideNavigationItem';
